import confetti from 'canvas-confetti';

export const wheel = () => {
  let angle = 90;

  const interval: NodeJS.Timeout = setInterval(() => {
    if (angle < -90) {
      clearInterval(interval);
      return;
    }
    confetti({
      angle: angle,
      spread: 10,
      zIndex: 201,
      particleCount: 50,
      origin: { y: 0.3 },
    });
    confetti({
      angle: angle + 180,
      spread: 10,
      zIndex: 201,
      particleCount: 50,
      origin: { y: 0.3 },
    });
    angle -= 10;
  }, 50);
};
